import React from 'react';
import TextInput, {
  filterNumericKeyPress,
} from '../../../components/TextInput';

export default function PrefillPhoneVerify(props) {
  return (
    <TextInput
      name="verify"
      label="Verification Code"
      validationData={props.validations}
      formData={props.formData}
      onChange={props.onChange}
      type="text"
      pattern="[0-9]{6}"
      maxLength="6"
      helpText="######"
      required
      onKeyPress={filterNumericKeyPress}
    />
  );
}
